import { RICH_TEXT_INPUT_SUPPORTED_HTML_TAGS } from "../constants";

const RICH_TEXT_INPUT_SUPPORTED_HTML_TAG_REGEX = new RegExp(
  `<(${RICH_TEXT_INPUT_SUPPORTED_HTML_TAGS.join("|")})(\\s+[^>]*)?>`,
  "g",
);

/**
 * Returns whether the provided text contains HTML tags.
 */
export function getHasHtml(text: string): boolean {
  return text.match(RICH_TEXT_INPUT_SUPPORTED_HTML_TAG_REGEX) != null;
}
